import { ASSESSMENT_TYPE } from '@web-platform/shared-universal-constants/src/booking/assessmentType';
import { nonNullishOrFallback } from '@web-platform/shared-universal-utils-frontend/src/helpers/assertNonNullish';

import type {
  SkyscannerSonarCommonV1Enums,
  SkyscannerSonarV3AmenityInfo,
} from '@skyscanner-internal/sonar-web-http-client';
import type { AssessmentType } from '@web-platform/shared-universal-constants/src/booking/assessmentType';
import type { AmenityInfoBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/segmentsBookingPanel';

type SonarAmenity = SkyscannerSonarV3AmenityInfo.Amenity;
type SonarAmenityInfo = SkyscannerSonarV3AmenityInfo.AmenityInfo;

export const mapSonarV3AmenityInfo = (
  sonarAmenityInfo?: SonarAmenityInfo,
): AmenityInfoBookingPanel | undefined => {
  if (!sonarAmenityInfo) {
    return undefined;
  }

  const mappedAmenity = {
    transportDescription: sonarAmenityInfo.transportDescription || undefined,
    layout: sonarAmenityInfo.layout || undefined,
    seatPitch: sonarAmenityInfo.seatPitch || undefined,
    meals: mapAmenity(sonarAmenityInfo.meals),
    wifi: mapAmenity(sonarAmenityInfo.wifi),
    entertainment: mapAmenity(sonarAmenityInfo.entertainment),
    power: mapAmenity(sonarAmenityInfo.power),
  };

  const hasAmenities = Object.values(mappedAmenity).some(Boolean);

  return hasAmenities ? mappedAmenity : undefined;
};

const mapSonarAssessment = (
  assessment: SkyscannerSonarCommonV1Enums.Assessment | undefined,
): AssessmentType | undefined => assessment && ASSESSMENT_TYPE[assessment];

const mapAmenity = (sonarAmenity: SonarAmenity | undefined) => {
  if (!sonarAmenity) {
    return undefined;
  }

  const assessmentStatus = mapSonarAssessment(
    nonNullishOrFallback(sonarAmenity.assessment, undefined, 'sonarAmenity.assessment'),
  );

  if (
    assessmentStatus !== ASSESSMENT_TYPE.ASSESSMENT_FEE &&
    assessmentStatus !== ASSESSMENT_TYPE.ASSESSMENT_INCLUDED
  ) {
    return undefined;
  }

  return nonNullishOrFallback(sonarAmenity.description, undefined, 'sonarAmenity.description');
};
